import { InfoFilled } from '@element-plus/icons-vue'
import { normalizeOptions } from '@formkit/inputs'
import { ElButton, ElDialog, ElIcon, ElRadio, ElRadioGroup } from 'element-plus'
import { computed, defineComponent, h, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isDialogVisible = ref(false)
    const selectedInfoText = ref('')
    const modalTitle = ref('')

    const showDialog = (infoText, title) => {
      selectedInfoText.value = infoText
      modalTitle.value = title || props.context.attrs?.modalTitle || ''
      isDialogVisible.value = true
    }

    const value = computed({
      get: () => props.context.value,
      set: (val) => {
        props.context.node.input(val)
        if (props.context.attrs?.onChangeCallback) {
          props.context.attrs.onChangeCallback(val, props.context.node)
        }
      },
    })

    const options = computed(() =>
      normalizeOptions(props.context.attrs?.options ?? []).map((option) => {
        const optionValue = option.__original ?? option.value
        const isActive = value.value === optionValue
        const activeColorClass = option.activeTextColor || 'text-primary-500'

        return h(
          ElRadio,
          {
            label: optionValue,
            class: props.context.attrs?.radioClasses,
            border: option.border !== undefined ? option.border : true,
          },
          () => [
            h('div', { class: 'flex items-center justify-between' }, [
              h(
                'span',
                {
                  class: ['transition-colors', 'font-normal', isActive ? activeColorClass : ''],
                },
                `${option.label}${option.showAsterisk ? ' *' : ''}`,
              ),
              option.info
                ? h(
                    ElIcon,
                    {
                      class: ['ml-1 cursor-pointer transition-colors', isActive ? activeColorClass : 'text-gray-400'],
                      size: '16',
                      onClick: (event) => {
                        event.stopPropagation()
                        showDialog(option.info, option.modalTitle)
                      },
                    },
                    () => h(InfoFilled),
                  )
                : null,
            ]),
            option.subLabel
              ? h(
                  'div',
                  {
                    class: 'text-xs text-gray-500 mt-0.5',
                  },
                  option.subLabel,
                )
              : null,
          ],
        )
      }),
    )

    onMounted(() => {
      if (value.value === undefined && props.context.attrs?.default !== undefined) {
        props.context.node.input(props.context.attrs.default)
      }
    })

    return () =>
      h('div', [
        h(
          ElRadioGroup,
          {
            modelValue: value.value,
            'onUpdate:modelValue': (val) => (value.value = val),
            class: props.context.attrs?.class,
            disabled: props.context.disabled,
          },
          () => options.value,
        ),
        h(
          ElDialog,
          {
            modelValue: isDialogVisible.value,
            'onUpdate:modelValue': (val) => (isDialogVisible.value = val),
            title: modalTitle.value,
            width: '75%',
            appendToBody: true,
            zIndex: 4000,
          },
          {
            default: () =>
              h('div', {
                innerHTML: selectedInfoText.value,
                style: {
                  maxHeight: '400px',
                  overflowY: 'auto',
                  padding: '16px',
                },
              }),
            footer: () =>
              h(
                'div',
                { class: 'text-right' },
                h(
                  ElButton,
                  {
                    type: 'primary',
                    onClick: () => (isDialogVisible.value = false),
                  },
                  () => 'Close',
                ),
              ),
          },
        ),
      ])
  },
})
